export const GET_CUSTOMERS_ATTACHMENTS_REQUEST = 'GET_CUSTOMERS_ATTACHMENTS_REQUEST';
export const GET_CUSTOMERS_ATTACHMENTS_SUCCESS = 'GET_CUSTOMERS_ATTACHMENTS_SUCCESS';
export const GET_CUSTOMERS_ATTACHMENTS_FAILURE = 'GET_CUSTOMERS_ATTACHMENTS_FAILURE';
